/**
 * Safer Object.hasOwnProperty
 */
function hasOwn(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = hasOwn;